import { SVGProps } from "react";

const Eye = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5c-5.05 0-9.29 3.36-10.68 7.24a1.02 1.02 0 000 .52C2.71 16.64 6.95 20 12 20s9.29-3.36 10.68-7.24a1.02 1.02 0 000-.52C21.29 8.36 17.05 5 12 5zm0 12.5c-3.86 0-6.9-2.4-8.16-5.5C5.1 8.9 8.14 6.5 12 6.5s6.9 2.4 8.16 5.5c-1.26 3.1-4.3 5.5-8.16 5.5zM12 8.75A3.25 3.25 0 1012 15.25 3.25 3.25 0 0012 8.75zm0 5A1.75 1.75 0 1112 10.25a1.75 1.75 0 010 3.5z"
      />
    </svg>
  );
};

export default Eye;
